import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";

// State
import { submitENewsSignup } from "../../store/actions/enews";

// CSS
import "./../../css/enews-form.css";

class ENewsForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			EMAIL: "",
			FNAME: "",
			LNAME: "",
			// Honeypot
			b_82cdabc1d242a337a8d9fefd9_a9584a5fca: "",
		};
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSubmit();
		}
	}

	handleInputChange(event) {
		const { name, value } = event.target;
		this.setState({
			[name]: value
		});
	}

	handleSubmit() {
		this.props.submitENewsSignup(this.state);
	}

	render() {
		return (
			<Fragment>
				{!isEmpty(this.props.errors) && (
					<div className="error">
						{Object.keys(this.props.errors).map(key => {
							return <div key={key}>{this.props.errors[key]}</div>;
						})}
					</div>
				)}
				<div className="enews_form" id="mc_embed_signup_scroll">
					<form action="https://muscederevineyards.us21.list-manage.com/subscribe/post?u=82cdabc1d242a337a8d9fefd9&amp;id=a9584a5fca&amp;f_id=0054f4e6f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank">
						<div id="mce-responses" className="clear">
							<div className="response" id="mce-error-response" style={{display: 'none'}}></div>
							<div className="response" id="mce-success-response" style={{display: 'none'}}></div>
						</div>
						<div className="mailing-list-names">
							<div className="mc-field-group">
								<input 
									type="text" 
									name="FNAME" 
									className="required text" 
									id="mce-FNAME" 
									placeholder="First Name" 
									aria-label="First Name"
									onKeyPress={e => this.handleKeyPress(e)}
									onChange={e => this.handleInputChange(e)}
								/>
							</div>
							<div className="mc-field-group">
								<input 
									type="text" 
									name="LNAME" 
									className="required text" 
									id="mce-LNAME" 
									placeholder="Last Name" 
									aria-label="Last Name"
									onKeyPress={e => this.handleKeyPress(e)}
									onChange={e => this.handleInputChange(e)}
								/>
							</div>
						</div>
						<div className="mailing-list-email-wrapper">
							<div className="mc-field-group">
								<input 
									type="email" 
									name="EMAIL" 
									className="required email" 
									id="mce-EMAIL" 
									placeholder="Subscribe to our E-Newsletter" 
									aria-label="Subscribe to our E-Newsletter"
									onKeyPress={e => this.handleKeyPress(e)}
									onChange={e => this.handleInputChange(e)}	
								/>
							</div>
							<div 
								aria-hidden="true" 
								style={{position: 'absolute', left: '-5000px'}}
							>
								<input 
									type="text" 
									name="b_82cdabc1d242a337a8d9fefd9_a9584a5fca" 
									tabIndex="-1" 
									onKeyPress={e => this.handleKeyPress(e)}
									onChange={e => this.handleInputChange(e)}
								/>
							</div>
							<button 
								type="submit"
								name="subscribe" 
								id="mc-embedded-subscribe" 
								className="button btn" 
							>
								<span>Join!</span>
							</button>
						</div>
					</form>
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		isLoading: state.enews.isLoading,
		errors: state.enews.errors,
		success: state.enews.success
	};
};

export default connect(
	mapStateToProps,
	{ submitENewsSignup }
)(ENewsForm);



// WEBPACK FOOTER //
// ./src/components/footer/ENewsForm.js